module.exports = __webpack_public_path__ + "img/he9.aed313fd.png";